<div
  *ngIf="this.task"
  class="container"
  [ngClass]="{ 'hide-container': showThreadOnly }"
  (click)="clickAnywhereOnDetail()"
>
  <div class="inner-container">
    <div class="main-section separator-border lower-section">
      <div class="top">
        <div class="top-left">
          <div class="parent-line">
            <ng-container
              *ngFor="let parentTask of parentTasks; last as isLast; index as i"
            >
              <div
                class="parent-title"
                [ngStyle]="{ 'padding-left.px': 2 + i * 10 }"
              >
                <span class="parent-separator">&#8735;&nbsp;</span>
                <a
                  [routerLink]="
                    taskDetailPath.split('/task/')[0] +
                    '/task/' +
                    parentTask._id
                  "
                  queryParamsHandling="merge"
                  >{{ parentTask.title }}</a
                >
              </div>
            </ng-container>
          </div>

          <div class="main-line">
            <input
              type="checkbox"
              class="task-checkbox task-checkbox-large"
              [(ngModel)]="completed"
              (change)="clickCheck()"
            />

            <textarea
              #titleTextArea
              class="title-textarea"
              spellcheck="false"
              [formControl]="titleControl"
              (keydown)="specialKeyPressInterceptTitle($event)"
              (focus)="onTitleTextareaFocus($event)"
              (blur)="onTitleTextareaBlur($event)"
              [maxlength]="taskTitleMaxLength"
            ></textarea>
          </div>

          <div
            *ngIf="
              space &&
              (context === 'inbox' || context === 'task-detail-page') &&
              userspaceCount > 1
            "
            class="space-name-line"
          >
            in {{ space.name }} space
          </div>
        </div>
        <div>
          <button
            mat-icon-button
            class="menu-button highlight-on-mouseover"
            [matMenuTriggerFor]="taskMenu"
            aria-label="Menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #taskMenu="matMenu">
            <button
              mat-menu-item
              *ngIf="!task.currentAt && !task.completedAt"
              (click)="setCurrent()"
            >
              <mat-icon>arrow_forward</mat-icon>
              <span>Set as current</span>
            </button>

            <button
              mat-menu-item
              *ngIf="task.currentAt && !task.completedAt"
              (click)="setBacklog()"
            >
              <mat-icon>arrow_back</mat-icon>
              <span>Send to backlog</span>
            </button>

            <button mat-menu-item (click)="openInput('assignedTo')">
              <mat-icon>person</mat-icon>
              Assign to...
            </button>

            <button mat-menu-item (click)="openInput('tag')">
              <mat-icon>sell</mat-icon>
              Tags...
            </button>

            <button
              mat-menu-item
              (click)="spaceId && taskService.openSchedule({ orgId, spaceId, taskId })"
            >
              <mat-icon>calendar_month</mat-icon>
              Due/Schedule...
            </button>

            <button
              *ngIf="task.completedAt"
              mat-menu-item
              (click)="spaceId && taskService.changeCompletedAt({ orgId, spaceId, taskId })"
            >
              <mat-icon>update</mat-icon>
              Change time task was set as completed
            </button>

            <button
              *ngIf="task.currentAt"
              mat-menu-item
              (click)="spaceId && taskService.changeCurrentAt({ orgId, spaceId, taskId })"
            >
              <mat-icon>update</mat-icon>
              Change time task was set as current
            </button>

            <button *ngIf="!task.trashedAt" mat-menu-item (click)="trashTask()">
              <mat-icon>delete</mat-icon>
              Trash task
            </button>

            <button
              *ngIf="task.trashedAt"
              mat-menu-item
              (click)="removeFromTrash()"
            >
              <mat-icon matListItemIcon> restore_from_trash </mat-icon>
              <span>Remove from trash</span>
            </button>

            <button
              *ngIf="task.trashedAt"
              mat-menu-item
              (click)="taskService.permanentlyDeleteTask(task)"
            >
              <mat-icon matListItemIcon> delete_forever </mat-icon>
              <span>Permanently delete task</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="bubble-line">
        <div
          *ngIf="task.trashedAt"
          class="bubble bubble-solid trash-bubble"
          [matMenuTriggerFor]="trashMenu"
        >
          🗑 In trash
        </div>
        <mat-menu #trashMenu="matMenu">
          <button mat-menu-item (click)="removeFromTrash()">
            <mat-icon matListItemIcon> restore_from_trash </mat-icon>
            <span>Remove from trash</span>
          </button>

          <button
            mat-menu-item
            (click)="taskService.permanentlyDeleteTask(task)"
          >
            <mat-icon matListItemIcon> delete_forever </mat-icon>
            <span>Permanently delete task</span>
          </button>
        </mat-menu>

        <div class="bubble bubble-solid" [matMenuTriggerFor]="stageMenu">
          {{ stage === 'complete' ? '✓' : '🕗' }} {{ stageText }}
        </div>
        <mat-menu #stageMenu="matMenu">
          <button mat-menu-item (click)="setBacklog()">
            <mat-icon matListItemIcon>
              {{ stage === 'backlog' ? 'done' : '' }}
            </mat-icon>
            <span>Backlog</span>
          </button>
          <button mat-menu-item (click)="setCurrent()">
            <mat-icon matListItemIcon>
              {{ stage === 'current' ? 'done' : '' }}
            </mat-icon>
            <span>Current</span>
          </button>
          <button mat-menu-item (click)="setComplete()">
            <mat-icon matListItemIcon>
              {{ stage === 'complete' ? 'done' : '' }}
            </mat-icon>
            <span>Complete</span>
          </button>
        </mat-menu>

        <div
          *ngIf="assignedToName"
          class="bubble bubble-solid"
          (click)="openInput('assignedTo')"
        >
          {{ assignedToName }}
        </div>
        <div
          *ngIf="!assignedToName"
          class="bubble bubble-outline"
          (click)="openInput('assignedTo')"
        >
          + User
        </div>

        <div
          *ngFor="let tagDisplay of tagsDisplay"
          class="bubble bubble-solid"
          (click)="openInput('tag')"
        >
          {{ tagDisplay.title }}
        </div>
        <div class="bubble bubble-outline" (click)="openInput('tag')">
          + Tag
        </div>

        <div
          *ngIf="dueText"
          class="bubble bubble-solid"
          (click)="spaceId && taskService.openSchedule({ orgId, spaceId, taskId })"
        >
          Due: {{ dueText }}
        </div>
        <div
          *ngIf="scheduleText"
          class="bubble bubble-solid"
          (click)="spaceId && taskService.openSchedule({ orgId, spaceId, taskId })"
        >
          <mat-icon>calendar_month</mat-icon>
          {{ scheduleText }}
        </div>
        <div
          *ngIf="!scheduleText"
          class="bubble bubble-outline"
          (click)="spaceId && taskService.openSchedule({ orgId, spaceId, taskId })"
        >
          + Due/Schedule
        </div>
      </div>

      <div class="task-input">
        <app-task-input
          *ngIf="inputType && spaceId"
          [orgId]="orgId"
          [spaceId]="spaceId"
          [taskId]="taskId"
          [inputType]="inputType"
          [launchSource]="inputLaunchSource"
          (returnToCursor)="returnToCursor($event)"
          (typeCharacter)="typeCharacter($event)"
          (closeInput)="closeTaskInput()"
        ></app-task-input>
      </div>

      <div
        class="task-detail-sub-header extra-padding-in-wide"
        (click)="clickDescription()"
      >
        <mat-icon *ngIf="!showDescription" class="chevron narrow-mode">
          chevron_right
        </mat-icon>
        <mat-icon *ngIf="showDescription" class="chevron narrow-mode">
          expand_more
        </mat-icon>
        <div class="sub-header-text task-detail-sub-header-text-style">
          Description
        </div>
        <div
          class="collapsed-right-text narrow-mode"
          *ngIf="!showDescription && task.description"
        >
          - {{ task.description }}
        </div>
      </div>
      <div
        class="description-line wide-mode extra-padding-in-wide"
        [ngClass]="{ 'display-none-override': showDescription }"
      >
        <textarea
          #descriptionTextArea
          class="description-textarea"
          [formControl]="descriptionControl"
          (keydown)="specialKeyPressInterceptDescription($event)"
          (focus)="onDescriptionTextareaFocus($event)"
          (blur)="onDescriptionTextareaBlur($event)"
          [maxlength]="taskDescriptionMaxLength"
        ></textarea>
      </div>

      <div
        class="task-detail-sub-header extra-padding-in-wide"
        (click)="clickSubtasks()"
      >
        <mat-icon *ngIf="!showChildren" class="chevron narrow-mode">
          chevron_right
        </mat-icon>
        <mat-icon *ngIf="showChildren" class="chevron narrow-mode">
          expand_more
        </mat-icon>
        <div class="sub-header-text task-detail-sub-header-text-style">
          Subtasks
        </div>
        <div
          class="collapsed-right-text narrow-mode"
          *ngIf="!showChildren && children.length"
        >
          - {{ children.length }}
        </div>
      </div>
      <div
        class="wide-mode subtasks-list narrow-scrollbar extra-padding-in-wide"
        [ngClass]="{ 'display-none-override': showChildren }"
      >
        <div *ngFor="let child of children; let i = index">
          <app-task
            *ngIf="spaceId"
            [listId]="listId"
            [orgId]="orgId"
            [spaceId]="spaceId"
            [taskId]="child.taskId"
            [contextDepth]="1"
            [expandToContextDepth]="child.task.completedAt ? 0 : 3"
            [inTaskDetail]="true"
            [siblings]="children"
            [parentTagIds]="this.task.tagIds"
            [moveCursorToDeepestChild]="
              moveCursorToDeepestChildTaskId === child.taskId
                ? { atStart: moveCursorToDeepestChildAtStart }
                : undefined
            "
            (moveCursorToPriorEmitter)="
              moveCursorToPrior($event.atStart, children[i - 1])
            "
            (moveCursorToNextEmitter)="
              moveCursorToNext($event.atStart, children[i + 1])
            "
          ></app-task>
        </div>
        <div class="add-task-button-detail">
          <button mat-button (click)="addNewTaskAtEnd()">
            <mat-icon mat-button-icon>add</mat-icon>
            Add subtask
          </button>
        </div>
      </div>
    </div>

    <div class="messages lower-section">
      <div
        class="task-detail-sub-header messages-sub-header"
        (click)="clickDiscussion()"
      >
        <mat-icon *ngIf="!showDiscussion" class="chevron narrow-mode">
          chevron_right
        </mat-icon>
        <mat-icon *ngIf="showDiscussion" class="chevron narrow-mode">
          expand_more
        </mat-icon>
        <div class="sub-header-text task-detail-sub-header-text-style">
          Discussion
        </div>
        <div
          class="collapsed-right-text narrow-mode"
          *ngIf="!showDiscussion && task.messageNumber"
        >
          - {{ task.messageNumber }}
        </div>
      </div>
      <div
        class="wide-mode"
        [ngClass]="{ 'display-none-override': showDiscussion }"
      >
        <app-thread-view
          *ngIf="!showThreadOnly"
          [isTask]="true"
          [orgId]="orgId"
          [refId]="taskId"
          [mode]="'task'"
          [context]="context"
        ></app-thread-view>
      </div>
    </div>

    <div class="bottom-spacer separator-border wide-mode"></div>
  </div>
</div>

<app-thread-view
  *ngIf="this.task && showThreadOnly"
  [isTask]="true"
  [orgId]="orgId"
  [refId]="taskId"
  [mode]="'task'"
  [context]="context"
></app-thread-view>
